import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/index',
        name: 'index',
        component: () => import('../views/index.vue'),
    },

    {
        path: '/apply',
        name: 'apply',
        component: () => import('../views/apply.vue'),
    },
    {
        path: '/edition',
        name: 'edition',
        component: () => import('../views/edition.vue'),
    },
    {
        path: '/editionpay',
        name: 'editionpay',
        component: () => import('../views/editionpay.vue'),
    },
    {
        path: '/word',
        name: 'word',
        component: () => import('../views/word.vue'),
    },
    {
        path: '/newviews',
        name: 'newviews',
        meta: {
            keepAlive: true // 是否使用 keep-alive
        },
        component: () => import('../views/newviews.vue'),
    },
    {
        path: '/newviewsdetail',
        name: 'newviewsdetail',
        component: () => import('../views/newviewsdetail.vue'),
    },
    {
        path: '/news_view',
        name: 'news_view',
        component: () => import('../views/news_view.vue'),
    },
    {
        path: '/news_view_mobile',
        name: 'new_view_mobile',
        component: () => import('../views/news_view_mobile')
    },
    {
        path: '/chat',
        name: 'chat',
        component: () => import('../views/chat.vue'),
    },
    {
        path: '/detail',
        name: 'detail',
        component: () => import('../views/detail.vue'),
    },
    {
        path: '/shop',
        name: 'shop',
        component: () => import('../views/shop.vue'),
    },
    {
        path: '/shoucang',
        name: 'shoucang',
        component: () => import('../views/shoucang.vue'),
    },
    {
        path: '/shop_mobile',
        name: 'shop_mobile',
        component: () => import('../views/shop_mobile.vue'),
    },
    {
        path: '/detail_mobile',
        name: 'detail_mobile',
        component: () => import('../views/detail_mobile.vue'),
    },
    {
        path: '/shoucang_mobile',
        name: 'shoucang_mobile',
        component: () => import('../views/shoucang_mobile.vue'),
    },
    {
        path: '/carOwner',
        name: 'carOwner',
        component: () => import('../views/carOwner.vue'),
    },
    {
        path: '/carOwner_mobile',
        name: 'carOwner_mobile',
        component: () => import('../views/carOwner_mobile.vue'),
    },
    {
        path: '/cargoOwner',
        name: 'cargoOwner',
        component: () => import('../views/cargoOwner.vue'),
    },
    {
        path: '/cargoOwner_mobile',
        name: 'cargoOwner_mobile',
        component: () => import('../views/cargoOwner_mobile.vue'),
    },

    {
        path: '/index_mobile',
        name: 'index_mobile',
        component: () => import('../views/index_mobile.vue'),
    },
    {
        path: '/newviews_mobile',
        name: 'newviews_mobile',
        meta: {
            keepAlive: true // 是否使用 keep-alive
        },
        component: () => import('../views/newviews_mobile.vue'),
    },
    {
        path: '/newviewsdetails_mobile',
        name: 'newviewsdetails_mobile',
        component: () => import('../views/newviewsdetails_mobile.vue'),
    },
    {
        path: '/apply_mobile',
        name: 'apply_mobile',
        component: () => import('../views/apply_mobile.vue'),
    },
    {
        path: '/edition_mobile',
        name: 'edition_mobile',
        component: () => import('../views/edition_mobile.vue'),
    },
    {
        path: '/editionpay_mobile',
        name: 'editionpay_mobile',
        component: () => import('../views/editionpay_mobile.vue'),
    },
    {
        path: '/chat_mobile',
        name: 'chat_mobile',
        component: () => import('../views/chat_mobile.vue'),
    },
    {
        path: '/word_mobile',
        name: 'word_mobile',
        component: () => import('../views/word_mobile.vue'),
    },

    /*忘记是干啥的了*/
    {
        path: '/editonpayp_mobile',
        name: 'editonpayp_mobile',
        component: () => import('../views/editonpayp_mobile.vue'),
    },
    {
        path: '/editonpayp',
        name: 'editonpayp',
        component: () => import('../views/editonpayp.vue'),
    },
    /*单独购买普惠云*/
    {
        path: '/editonpurchase',
        name: 'editonpurchase',
        component: () => import('../views/editonpurchase.vue'),
    },
    {
        path: '/editonpurchase_mobile',
        name: 'editonpurchase_mobile',
        component: () => import('../views/editonpurchase_mobile.vue'),
    },



    /*   children: [
            {
                path: "/index1",
                name: "index1",
                component: () => import ('../views/index1.vue')
            },
            {
                path: "/index2",
                name: "index2",
                component: () => import ('../views/index2.vue')
            },
        ],
    }*/
]

const router = new VueRouter({
    routes
})
/** 解决跳转重复路由报错问题 */
// 解决两次访问相同路由地址报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router